import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { useRouteError } from 'react-router';

/** O que aparece quando uma página quebra. O erro vai ao console; a pessoa, de volta ao início. */
export function ErrorPage() {
  const error = useRouteError();

  if (import.meta.env.DEV) {
    console.error(error);
  }

  return (
    <Container maxWidth="sm" sx={{ py: 12, textAlign: 'center' }}>
      <Typography variant="h2" component="h1" sx={{ mb: 2 }}>
        Algo deu errado
      </Typography>
      <Typography sx={{ color: 'text.secondary', mb: 4 }}>
        A página não conseguiu carregar. Tente de novo ou volte ao início.
      </Typography>
      <Button href="/" variant="contained" size="large">
        Voltar ao início
      </Button>
    </Container>
  );
}
